// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-PurchaseOrder-PurchaseOrderDetail-Separator-__Separator___3feq-"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/PurchaseOrder/PurchaseOrderDetail/Separator/Separator.css
// module id = 2136
// module chunks = 0